<section class="forbidden-page">
  <h2>Acces interdit</h2>
  <p>Votre groupe utilisateur ne permet pas d'acceder a cette page.</p>
  <button type="button" (click)="goBack()">Retour a l'accueil intranet</button>
</section>
